import { lazyWithPreload } from '@kk/shared/utils/async';
import type { ExtendedRouteObject } from '@/routes/types';
import loader, { id, type LoaderData, type Params } from './loader';

const NewAgreementPage = lazyWithPreload(async () => await import('./index'));

const NewAgreement = lazyWithPreload(
  async () => await import('./NewAgreement/NewAgreement'),
);

const NewAgreementCalculateAndApplyTab = lazyWithPreload(
  async () => await import('./NewAgreement/NewAgreementCalculateAndApplyTab'),
);

const NewAgreementDraftsTab = lazyWithPreload(
  async () => await import('./NewAgreement/NewAgreementDraftsTab'),
);

export default {
  id,
  path: '/new-agreement',
  loader,
  shouldRevalidate: () => false,
  element: <NewAgreementPage />,
  children: [
    {
      id: 'new-agreement-layout',
      path: '',
      element: <NewAgreement />,
      children: [
        {
          id: 'new-agreement-calculate-and-apply-tab',
          index: true,
          element: <NewAgreementCalculateAndApplyTab />,
        },
        {
          id: 'new-agreement-drafts-tab',
          path: 'drafts',
          element: <NewAgreementDraftsTab />,
        },
      ],
    },
  ],
  handle: () => ({
    preload: async () => await NewAgreementPage.preload(),
  }),
} as const satisfies ExtendedRouteObject<Params, LoaderData>;
